import type { i18n } from 'i18next';

export function syncDocumentLanguage(instance: i18n): void {
	const applyLanguage = (language: string) => {
		if (language) {
			document.documentElement.lang = language;
		}
	};

	if (instance.isInitialized && instance.language) {
		applyLanguage(instance.language);
	}

	instance.on('initialized', () => {
		applyLanguage(instance.language);
	});

	instance.on('languageChanged', (language) => {
		applyLanguage(language);
	});
}
